import React, { createContext, useContext } from 'react';

/**
 * Storage configuration context
 * Provides information about which storage mechanism is being used
 */
interface StorageConfigContextType {
  storageType: 'session' | 'local';
  storage: Storage;
}

const StorageConfigContext = createContext<StorageConfigContextType>({
  storageType: 'session',
  storage: typeof window !== 'undefined' ? window.sessionStorage : ({} as Storage),
});

export const StorageConfigProvider: React.FC<{
  storageType: 'session' | 'local';
  children: React.ReactNode;
}> = ({ storageType, children }) => {
  const storage = storageType === 'local' ? window.localStorage : window.sessionStorage;

  return (
    <StorageConfigContext.Provider value={{ storageType, storage }}>
      {children}
    </StorageConfigContext.Provider>
  );
};

/**
 * Hook to access the configured storage
 */
export const useStorageConfig = () => useContext(StorageConfigContext);
